import React, { Component } from 'react';

class PaymentWarningBanner extends Component {
  static propTypes = {
    warningType: React.PropTypes.string.isRequired,
  }
  componentWillMount() {
    return false;
  }
  shouldComponentUpdate() {
    return false;
  }
  render() {
    const { warningType } = this.props;
    /*
      When the app gets mounted on the client, it re-renders this component and results in overwriting the banner html.
      To overcome this we check if there is a window object defined and sets the banner's innerHTML to the html that was rendered on the server side.
    */
    if (typeof window !== 'undefined') {
      const node = document.getElementById('paymentwarning-banner_id');
      const html = node.innerHTML;
      return (
        <div id="paymentwarning-banner_id" className="paymentwarning-banner" data-warningtype={warningType} dangerouslySetInnerHTML={{ __html: html }} />
      );
    }
    return (
      <div id="paymentwarning-banner_id" className="paymentwarning-banner" data-warningtype={warningType} />
    );
  }
}

export default PaymentWarningBanner;



// WEBPACK FOOTER //
// ./src/components/PaymentWarningBanner/PaymentWarningBanner.js